import { OnInit, } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { DatastoreCollection, toNumber, } from '@freelancer/datastore';
import { ModalService } from '@freelancer/ui';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { VerticalAlignment } from '@freelancer/ui/grid';
import { HeadingSize } from '@freelancer/ui/heading';
import { IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { ModalSize } from '@freelancer/ui/modal';
import { FontColor, FontSize, FontWeight } from '@freelancer/ui/text';
import { ContentTypeApi } from 'api-typings/users/users';
import { HireMeWebappModalComponent } from 'app/hire-me/hire-me-webapp-modal/hire-me-webapp-modal.component';
import * as Rx from 'rxjs';
import { map, take } from 'rxjs/operators';
var UserPortfolioItemOverlayComponent = /** @class */ (function () {
    function UserPortfolioItemOverlayComponent(auth, modalService) {
        this.auth = auth;
        this.modalService = modalService;
        this.ButtonColor = ButtonColor;
        this.ButtonSize = ButtonSize;
        this.FontColor = FontColor;
        this.FontSize = FontSize;
        this.FontWeight = FontWeight;
        this.HeadingSize = HeadingSize;
        this.IconSize = IconSize;
        this.Margin = Margin;
        this.VerticalAlignment = VerticalAlignment;
    }
    UserPortfolioItemOverlayComponent.prototype.ngOnInit = function () {
        this.itemSkills$ = Rx.combineLatest([
            this.skillsCollection.valueChanges(),
            this.portfolioItem$,
        ]).pipe(map(function (_a) {
            var skills = _a[0], item = _a[1];
            return skills.filter(function (s) { return item.jobs.includes(s.id); });
        }));
        this.itemCategories$ = Rx.combineLatest([
            this.categoriesCollection.valueChanges(),
            this.portfolioItem$,
        ]).pipe(map(function (_a) {
            var categories = _a[0], item = _a[1];
            return categories.filter(function (c) { return item.categories.includes(c.id); });
        }));
        this.darkBackground$ = this.portfolioItem$.pipe(map(function (item) {
            return item.contentType === ContentTypeApi.AUDIO ||
                item.contentType === ContentTypeApi.VIDEO;
        }));
        this.isViewerProfileOwner$ = Rx.combineLatest([
            this.user$.pipe(map(function (user) { return user.id; })),
            this.auth.getUserId().pipe(map(toNumber)),
        ]).pipe(map(function (_a) {
            var profileUserId = _a[0], userId = _a[1];
            return profileUserId === userId;
        }));
    };
    UserPortfolioItemOverlayComponent.prototype.hiremeAction = function () {
        var _this = this;
        this.modalService.close();
        this.hireMeUser$
            .pipe(take(1))
            .toPromise()
            .then(function (hireMeUser) {
            var userId = hireMeUser.profileUserId;
            _this.modalService.open(HireMeWebappModalComponent, {
                inputs: {
                    profileUserId: userId,
                },
                size: ModalSize.XSMALL,
                edgeToEdge: true,
            });
        });
    };
    return UserPortfolioItemOverlayComponent;
}());
export { UserPortfolioItemOverlayComponent };
